export default {
  fontSize: '0.83rem',
  textAlign: 'left',
  justifyContent: 'flex-start'
}



// WEBPACK FOOTER //
// ./src/styles/buttons/resources.js